import script from "./SupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportPage.vue?vue&type=script&setup=true&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=6e6e1e26&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6e1e26"]])

export default __exports__